export const checkIfCompanyCertificateError = (datetimeExpiracaoCertificado) => {
  if (!datetimeExpiracaoCertificado) return true;
  if (new Date(datetimeExpiracaoCertificado) < new Date()) return true;
  return false;
};
